"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelPopoverStyle = exports.LabelPopoverContentStyle = exports.IconCellWrapper = exports.LabelDetailAssetStyle = exports.LabelDetailPermissionRequired = exports.LabelDetailMessageStyle = exports.LabelDetailDateStyle = exports.LabelDetailAuthorStyle = exports.CertificationIconWrapperStyle = exports.LabelAssetChildGroupDiv = exports.LabelGroupHeadingDiv = exports.LabelLabelsGroupDiv = exports.LabelAssetGroupDiv = exports.LabelIconClass = exports.LabelPopoverWidth = void 0;
var widgets_1 = require("@tableau/widgets");
var LayoutComponents_1 = require("../style/LayoutComponents");
var StyleFunctions_1 = require("../style/StyleFunctions");
var Typography = widgets_1.TabStyles.Typography;
var Spacing = widgets_1.TabStyles.Spacing;
exports.LabelPopoverWidth = 400;
exports.LabelIconClass = (0, StyleFunctions_1.cssClass)('LabelIconClass', {
    verticalAlign: 'text-bottom'
});
exports.LabelAssetGroupDiv = (0, LayoutComponents_1.divWithStyle)('LabelAssetGroupDiv', {
    paddingLeft: 12,
    fontSize: Typography.Sizing.Default,
});
exports.LabelLabelsGroupDiv = (0, LayoutComponents_1.divWithStyle)('LabelLabelsGroupDiv', {
    paddingLeft: 28,
});
exports.LabelGroupHeadingDiv = (0, LayoutComponents_1.divWithStyle)('LabelGroupHeadingDiv', {
    fontWeight: 'bold',
    color: '#4F4F4F',
    marginBottom: 8,
    fontSize: Typography.Sizing.Default,
});
exports.LabelAssetChildGroupDiv = (0, LayoutComponents_1.divWithStyle)('LabelAssetChildGroupDiv', {
    marginLeft: -12,
    fontSize: Typography.Sizing.Default,
});
exports.CertificationIconWrapperStyle = (0, LayoutComponents_1.divWithStyle)('CertificationIconWrapperStyle', {
    marginTop: 8,
    marginBottom: 8,
    marginRight: 4,
});
exports.LabelDetailAuthorStyle = (0, LayoutComponents_1.divWithStyle)('LabelDetailAuthor', {
    color: Typography.Color.Secondary,
    fontSize: Typography.Sizing.Default,
    marginTop: 8,
    marginBottom: 8,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
});
exports.LabelDetailDateStyle = (0, LayoutComponents_1.divWithStyle)('LabelDetailDate', {
    color: Typography.Color.Secondary,
    fontSize: Typography.Sizing.Default,
    marginBottom: 8
});
exports.LabelDetailMessageStyle = (0, LayoutComponents_1.divWithStyle)('LabelDetailMessage', {
    width: 255,
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
    $nest: {
        p: {
            marginTop: 0,
            marginBottom: 16
        }
    }
});
exports.LabelDetailPermissionRequired = {
    color: 'rgba(0,0,0,0.56)',
};
exports.LabelDetailAssetStyle = (0, LayoutComponents_1.divWithStyle)('LabelDetailAsset', {
    fontWeight: 'bold',
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
    marginTop: Spacing.DefaultSpace,
    marginBottom: Spacing.DefaultSpace,
    textOverflow: 'ellipsis',
    display: 'flex',
    whiteSpace: 'pre-wrap',
    overflow: 'hidden'
});
exports.IconCellWrapper = (0, LayoutComponents_1.divWithStyle)('label-cell', {
    position: 'relative',
    left: '13.4px',
    top: '2px'
});
exports.LabelPopoverContentStyle = {
    padding: 0,
    marginRight: 0,
    // Set the maximum height of both the dialog and its body for IE11 compatibility.
    maxHeight: 500,
};
exports.LabelPopoverStyle = {
    $nest: (_a = {},
        // when reference is hidden from view, hide popper
        _a["&[".concat('data-popper-reference-hidden', "^=\"true\"]")] = {
            display: 'none',
            pointerEvents: 'none',
        },
        _a)
};
//# sourceMappingURL=Styles.js.map